import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const ReturnsFlagKey = {
  ENABLE_MODALLESS_PORTAL: featureFlagKey("enable-modalless-portal"), // Gate the modalless customer portal experience. Default OFF.
  ADVANCED_EXCHANGE_PRODUCT_GRID: featureFlagKey(
    "advanced-exchange-product-grid",
  ), // Show the advanced exchange agent's ranked products as a grid instead of one product. Default OFF.
  RECOMMENDATION_POPUP: featureFlagKey("recommendation-popup"), // Present a single-product exchange recommendation as a popup instead of a full page. Default OFF.
  INSPECT_BEFORE_REFUND: featureFlagKey("inspect-before-refund"), // Reorder processing to inspect/restock items before issuing refund
  MANAGED_RETURNS_TRIAL_ONBOARDING: featureFlagKey(
    "managed-returns-trial-onboarding",
  ), // Gate the Managed Returns trial onboarding to targeted merchant admins
  AUTO_SUBMIT_CLAIMS: featureFlagKey("auto-submit-claims"), // Auto Submit Claims; evaluated per submission method (method attribute in context)
  RETURN_PROCESSING_FLOWS: featureFlagKey("return-processing-flows"), // Enable advanced flow editor for return processing (replaces return/claim processing automations)
  COMPENSATION_AND_RESTOCKING_FLOWS: featureFlagKey(
    "compensation-and-restocking-flows",
  ), // Dark launch: run Compensation and Restocking flows alongside Return Processing Flows on return-ready triggers
  ZIP_CODE_FRAUD: featureFlagKey("zip-code-fraud"), // Enable ZIP-code-based return fraud review in the merchant app
  LIQUIDONATE_DONATION_ROUTING: featureFlagKey("liquidonate-donation-routing"), // Enable Liquidonate donation routing option in the location flow editor
  INTERNATIONAL_RETURNS_READINESS: featureFlagKey(
    "international-returns-readiness",
  ), // Gate the intl-returns customs-readiness RPC/alert/banner. Default OFF.
  EXCHANGE_API_MULTIPLE_RETURNS: featureFlagKey(
    "exchange-api-multiple-returns",
  ), // Create separate Shopify returns for exchange-API return product groups. Per team, default OFF.
  SHOPIFY_RETURNS: featureFlagKey("shopify-returns"), // Shopify return lifecycle for exchange-API returns; per team, default "old".
  SHOPIFY_RETURNS_RETURNABLE_QUANTITY: featureFlagKey(
    "shopify-returns-returnable-quantity",
  ), // When ON, use non-Redo Shopify returns instead of refunds to determine remaining returnable quantity. Per team, default OFF.
  SHOPIFY_RETURNS_BILLING_ENFORCE: featureFlagKey(
    "shopify-returns-billing-enforce",
  ), // When ON: disable the customer portal for teams past the 14-day Shopify returns billing acceptance deadline
  NEW_EXCHANGE_FINANCIAL_STRATEGY: featureFlagKey(
    "new-exchange-financial-strategy",
  ), // Show exchange financial strategy card even when NONE; hide legacy dropdown
  REDO_ASSISTED_CUSTOMS: featureFlagKey("redo-assisted-customs"), // Redo-assisted customs classification for returns: settings card + scheduled generation. Per team, default OFF.
} as const;
